import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import {
  Notification1y91jemwm75tr as Notification,
  Companion_getInstanceddq4orui8c5e as Companion_getInstance,
} from '../../../../../lightning-server-notifications-shared/com/lightningkite/lightningserver/notifications/notificationModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  ID2ebczrc12h07k as ID,
  Companion_instancef6fjaxfv49x1 as Companion_instance,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/models.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import {
  TCGNotification15rsix3sbs9g0 as TCGNotification,
  Companion_instance9ofeumbwb97p as Companion_instance_0,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/notifications.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_createdAt1oxi5pjv9saww as get_createdAt,
  get_usersuhqswqrijs4 as get_user,
  get_read2fqnxj4c930ns as get_read,
} from '../../../../../lightning-server-notifications-shared/com/lightningkite/lightningserver/notifications/ModelFields-2090458501.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance_1,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../sdk/currentSession.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { eq353yrgcpovoi1 as eq } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import {
  and3dbt2f202um49 as and,
  And1a3dbpwh0hxmu as And,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { ModificationBuilder10ot0rvxki4iq as ModificationBuilder } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ModificationBuilder.mjs';
import { now2qufyxzn5e863 as now } from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import { MassModification2547e91qtpdf9 as MassModification } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/MassModification.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { onNavigate2wu3qzsseblgb as onNavigate } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  Link$_get_to_$ref_jq7esp1qhuglz6kwpan as Link$_get_to_$ref_jq7esp,
  Link$_set_to_$ref_i9gu5xmkiv49juwaf as Link$_set_to_$ref_i9gu5x,
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
  IconView$_get_description_$ref_x7iif61khv8gb32hpy6 as IconView$_get_description_$ref_x7iif6,
  IconView$_set_description_$ref_rpvc1e1z9j41dqp1rw7 as IconView$_set_description_$ref_rpvc1e,
  IconView$_get_shown_$ref_js8irt2lifqkpdy4lgk as IconView$_get_shown_$ref_js8irt,
  IconView$_set_shown_$ref_9ilxmras82mdlnvzt8 as IconView$_set_shown_$ref_9ilxmr,
  IconView$_get_visible_$ref_7ldslk51pr2ktrf3cy as IconView$_get_visible_$ref_7ldslk,
  IconView$_set_visible_$ref_mp0dqc3hhaf8c2nn3ih as IconView$_set_visible_$ref_mp0dqc,
} from '../App.mjs';
import {
  substringAfter35b3qhto7hchb as substringAfter,
  substringAfter1hku067gwr5ve as substringAfter_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Companion_getInstance1h51zwdsitw8c as Companion_getInstance_1 } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import { get_AutoRoutes2trt04tweryz2 as get_AutoRoutes } from './autoroutes.mjs';
import {
  Empty_instancerdfpp8xjdvlo as Empty_instance,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import {
  plus354lvypr4cqa1 as plus,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
  None_instance1vdtnxdfytk8h as None_instance,
  CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance,
  renderToStringprxvmjepz2st as renderToString,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import {
  UnreadNotificationSemantic_getInstance2xhggpn2jfpdt as UnreadNotificationSemantic_getInstance,
  SmallTextSemantic_getInstance3ht14r7yzc9rl as SmallTextSemantic_getInstance,
} from '../theme/semantics.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance_2,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_2,
  toDuration28gf6ughsr3vf as toDuration,
  toDuration7gy6v749ektt as toDuration_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  DurationUnit_MINUTES_getInstance33ilufdckt9os as DurationUnit_MINUTES_getInstance,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { debounce3vjzafx7e7d30 as debounce } from '../../../../../reactive/com/lightningkite/reactive/extensions/debounce.mjs';
import {
  first58ocm7j58k3q as first,
  toList3jhuyej2anx2q as toList,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  NotificationFilters2kj3bq3y0683j as NotificationFilters,
  notificationFilters1u2w2erv5f4mj as notificationFilters,
  notificationFilterChipsfj5o61l0xxdo as notificationFilterChips,
} from './NotificationFilters.mjs';
import {
  allTextFieldsContain2y4ctgpgxc740 as allTextFieldsContain,
  textSearchConditionr2nfggw95qef as textSearchCondition,
  searchField2rc6mst1no9ok as searchField,
} from './components/search.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  maxWidth22r11xnm7d4h4 as maxWidth,
  sortSelect2bs9xha2fqnl1 as sortSelect,
} from './components/view-utilities.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  themed2vu67ornd4jps as themed,
  dynamicThemed3lsusnjffkq9e as dynamicThemed,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  get_atBottomStart1iulwjfo1udg3 as get_atBottomStart,
  get_centered31th09q7x90sf as get_centered,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_3 } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_3,
  tableRecycler3rsrjjwywx3ie as tableRecycler,
} from './components/table.mjs';
import { get_circleFilled1igein81c6nk0 as get_circleFilled } from '../icons.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function NotificationListPage$SortOption$Companion$_anonymous__qsu4r4() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.views.NotificationListPage.SortOption', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(TCGNotification()), arrayOf([]), false))]), false));
  var tmp$ret$4 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$4);
  this_0.descending_tl4o2_k$(get_createdAt(it));
  var tmp$ret$0 = this_0.build_1k0s4u_k$();
  SortOption_Newest_instance = new (SortOption())('Newest', 0, 'Newest first', tmp$ret$0);
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_1 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(TCGNotification()), arrayOf([]), false))]), false));
  var tmp$ret$10 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$10);
  this_1.ascending_ijynum_k$(get_createdAt(it_0));
  var tmp$ret$6 = this_1.build_1k0s4u_k$();
  SortOption_Oldest_instance = new (SortOption())('Oldest', 1, 'Oldest first', tmp$ret$6);
  if (Companion_instance_4 === VOID) {
    Companion_instance_1;
    new (Companion())();
  }
}
var SortOption_Newest_instance;
var SortOption_Oldest_instance;
function values() {
  static_init();
  return [SortOption_Newest_getInstance(), SortOption_Oldest_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_4 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, NotificationListPage$SortOption$Companion$_anonymous__qsu4r4);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  static_init();
  return Companion_instance_4;
}
var $ENTRIES;
var SortOptionClass;
function SortOption() {
  if (SortOptionClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName, sort) {
        super(name, ordinal);
        this.displayName_1 = displayName;
        this.sort_1 = sort;
      }
    }
    initMetadataForClass($, 'SortOption', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_4});
    SortOptionClass = $;
  }
  return SortOptionClass;
}
function NotificationListPage$_get_title_$lambda_7g2haa($this$remember) {
  return 'Notifications';
}
function NotificationListPage$render$lambda$lambda(it) {
  return it.displayName_1;
}
function NotificationListPage$render$lambda($this$invoke) {
  return 'Mark all as read';
}
function NotificationListPage$render$lambda_0($this$invoke) {
  return 'Mark all as read';
}
function NotificationListPage$render$slambda() {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).get_notifications_jts33z_k$();
    // Inline function 'com.lightningkite.services.database.condition' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(TCGNotification()), arrayOf([]), false))]), false));
    var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$3);
    var tmp_1 = get_user(it);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_currentSessionNotNull();
    var tmp$ret$6 = yield* await_0(this_1, $completion);
    var tmp_2 = and(eq(tmp_1, new (ID())(tmp$ret$6.userId_1)), eq(get_read(it), null));
    // Inline function 'com.lightningkite.services.database.modification' call
    // Inline function 'kotlin.apply' call
    var this_2 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_3 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(TCGNotification()), arrayOf([]), false))]), false));
    var tmp$ret$11 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
    var it_0 = new (DataClassPathSelf())(tmp$ret$11);
    this_2.assign_vtsfu6_k$(get_read(it_0), now());
    var tmp$ret$7 = this_2.build_1k0s4u_k$();
    yield* tmp.bulkModify_ugvnv2_k$(new (MassModification())(tmp_2, tmp$ret$7), $completion);
    return Unit_instance;
  }), 0);
}
function NotificationListPage$render$lambda_1($this$tableRecycler, r) {
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Link())($this$tableRecycler.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$tableRecycler.willAddChild_hz2iwc_k$(element);
  onNavigate(element, VOID, VOID, VOID, NotificationListPage$render$lambda$slambda(r));
  var tmp = KMutableProperty0();
  var tmp_0 = Link$_get_to_$ref_jq7esp(element);
  var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(r).content_1.url_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp$ret$4;
      $l$block: {
        var myPart = substringAfter_0(substringAfter(tmp0_safe_receiver, '://'), _Char___init__impl__6a9atx(47));
        var urlLike = Companion_getInstance_1().fromUrlString_j9awpo_k$(myPart);
        if (get_AutoRoutes().parse_l5bwev_k$(urlLike) == null) {
          tmp$ret$4 = null;
          break $l$block;
        }
        tmp$ret$4 = () => {
          var tmp0_elvis_lhs = get_AutoRoutes().parse_l5bwev_k$(urlLike);
          return tmp0_elvis_lhs == null ? Empty_instance : tmp0_elvis_lhs;
        };
      }
      tmp = tmp$ret$4;
    }
    return tmp;
  });
  element.onStartup_vrxh3i_k$();
  $this$tableRecycler.addChild_2qpft2_k$(element);
  return element;
}
function NotificationListPage$render$lambda$slambda($r) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).get_notifications_jts33z_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $r;
    var tmp$ret$1 = yield* await_0(this_1, $completion);
    var tmp_0 = tmp.get_6ueaa7_k$(tmp$ret$1._id_1);
    // Inline function 'com.lightningkite.services.database.modification' call
    // Inline function 'kotlin.apply' call
    var this_2 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_1 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(TCGNotification()), arrayOf([]), false))]), false));
    var tmp$ret$6 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$6);
    this_2.assign_vtsfu6_k$(get_read(it), now());
    var tmp$ret$2 = this_2.build_1k0s4u_k$();
    yield* tmp_0.modify_ff53f_k$(tmp$ret$2, $completion);
    return Unit_instance;
  }), 0);
}
function NotificationListPage$render$lambda_2($this$custom) {
  return 'Notification';
}
function NotificationListPage$render$lambda$lambda_0($this$invoke) {
  return 'Unread';
}
var NotificationListPage$render$$inlined$page$12$7$1Class;
function NotificationListPage$render$$inlined$page$12$7$1() {
  if (NotificationListPage$render$$inlined$page$12$7$1Class === VOID) {
    class $ {
      invoke_h6mny6_k$(theme) {
        return theme.copy$default_vpegf4_k$('bold', VOID, theme.font_1.copy$default_d05kcn_k$(VOID, VOID, true)).withoutBack_1;
      }
    }
    protoOf($).plus_duvq05_k$ = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    NotificationListPage$render$$inlined$page$12$7$1Class = $;
  }
  return NotificationListPage$render$$inlined$page$12$7$1Class;
}
function NotificationListPage$render$lambda_3($this$text) {
  return 'Received';
}
function NotificationListPage$render$lambda_4($this$text, it) {
  return renderToString(it.createdAt_1, RenderSize_Abbreviation_getInstance());
}
function NotificationListPage$render$lambda_5($this$tableRecycler, row) {
  return row.read_1 == null ? UnreadNotificationSemantic_getInstance() : None_instance;
}
function NotificationListPage$render$lambda_6($this$shownWhen) {
  return get_current(Companion_instance_2).equals(Platform_Web_getInstance());
}
function SortOption_Newest_getInstance() {
  static_init();
  return SortOption_Newest_instance;
}
function SortOption_Oldest_getInstance() {
  static_init();
  return SortOption_Oldest_instance;
}
var NotificationListPageClass;
function NotificationListPage() {
  if (NotificationListPageClass === VOID) {
    class $ {
      constructor() {
        this.textSearch_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$('');
        var tmp = this;
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance_2();
        var tmp$ret$0 = toDuration(0.25, DurationUnit_SECONDS_getInstance());
        tmp.debouncedTextSearch_1 = debounce(this.textSearch_1, tmp$ret$0, get_AppScope());
        this.sortBy_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(first(get_entries()));
        this.filter_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(new (NotificationFilters())());
        var tmp_0 = this;
        tmp_0.condition_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var session = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull());
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(TCGNotification()), arrayOf([]), false))]), false));
          var tmp$ret$3 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$3);
          var mine = eq(get_user(it), new (ID())(session.userId_1));
          var notificationSerializer = Companion_getInstance().serializer_o2vhsn_k$(Companion_instance.serializer_9w0wvi_k$(), Companion_instance_0.serializer_9w0wvi_k$());
          var tmp_0 = $this$remember.invoke_r7m7el_k$(this.debouncedTextSearch_1);
          var search = textSearchCondition(tmp_0, (word) => allTextFieldsContain(notificationSerializer, word));
          return And().new_com_lightningkite_services_database_Condition_And_ln02sz_k$([mine, search, $this$remember.invoke_r7m7el_k$(this.filter_1).toCondition_oj74tc_k$()]);
        });
        var tmp_1 = this;
        tmp_1.notifications_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_notifications_jts33z_k$();
          var tmp_0 = new (Query())($this$remember.invoke_r7m7el_k$(this.condition_1), $this$remember.invoke_r7m7el_k$(this.sortBy_1).sort_1, VOID, 50);
          // Inline function 'kotlin.time.Companion.minutes' call
          Companion_getInstance_2();
          var tmp$ret$6 = toDuration_0(1, DurationUnit_MINUTES_getInstance());
          return $this$remember.invoke_r7m7el_k$(tmp.list$default_sjz00l_k$(tmp_0, VOID, tmp$ret$6));
        });
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, NotificationListPage$_get_title_$lambda_7g2haa);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance_0().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_2 = themed(element, CompactSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_2.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_3 = get_atBottomStart(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_4 = weight(this_3, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_4.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.get_title_iz32un_k$()));
        element_1.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_1);
        searchField(element_0, this.textSearch_1);
        sortSelect(element_0, ($this$sortSelect) => {
          var tmp = _Constant___init__impl__v45mub(toList(get_entries()));
          $this$sortSelect.bind_64a41i_k$(this.sortBy_1, new (Constant())(tmp), NotificationListPage$render$lambda$lambda);
          return Unit_instance;
        });
        notificationFilters(element_0, this.filter_1);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_5 = themed(element_0, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Button())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_5.willAddChild_hz2iwc_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_6 = themed(element_2, LabelGapSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RowOrCol())(this_6.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_6.willAddChild_hz2iwc_k$(element_3);
        element_3.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
        var this_7 = get_centered(element_3);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (IconView())(this_7.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_7.willAddChild_hz2iwc_k$(element_4);
        element_4.set_source_3o5lkf_k$(Companion_getInstance_3().done_1.resize_q1xpz0_k$(get_rem(1)));
        var tmp_2 = KMutableProperty0();
        var tmp_3 = IconView$_get_description_$ref_x7iif6(element_4);
        var tmp_4 = getPropertyCallableRef('description', 0, tmp_2, tmp_3, IconView$_set_description_$ref_rpvc1e(element_4));
        element_4.invoke_bnq13k_k$(tmp_4, NotificationListPage$render$lambda);
        element_4.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_8 = get_centered(element_3);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (TextView())(this_8.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_8.willAddChild_hz2iwc_k$(element_5);
        var tmp_5 = KMutableProperty0();
        var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_5);
        var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_5));
        element_5.invoke_bnq13k_k$(tmp_7, NotificationListPage$render$lambda_0);
        element_5.onStartup_vrxh3i_k$();
        this_8.addChild_2qpft2_k$(element_5);
        element_3.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_3);
        onClick(element_2, VOID, VOID, VOID, NotificationListPage$render$slambda());
        element_2.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_2);
        element_0.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_0);
        notificationFilterChips(element, this.filter_1);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp_8 = weight(element, 1.0);
        var tmp_9 = remember(VOID, VOID, VOID, VOID, ($this$remember) => this.notifications_1);
        var tmp_10 = NotificationListPage$render$lambda_1;
        var tmp_11 = Companion_instance_3;
        var tmp_12 = NotificationListPage$render$lambda_2;
        var tmp_13 = tmp_11.custom_k0krgj_k$(tmp_12, 2.0, ($this$custom, it) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())($this$custom.get_context_h02k06_k$());
          ensureOutermostElement(element);
          $this$custom.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (IconView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_source_3o5lkf_k$(get_circleFilled(Companion_getInstance_3()).resize_q1xpz0_k$(get_rem_0(1.25)));
          var tmp = KMutableProperty0();
          var tmp_0 = IconView$_get_description_$ref_x7iif6(element_0);
          var tmp_1 = getPropertyCallableRef('description', 0, tmp, tmp_0, IconView$_set_description_$ref_rpvc1e(element_0));
          element_0.invoke_bnq13k_k$(tmp_1, NotificationListPage$render$lambda$lambda_0);
          var tmp_2 = KMutableProperty0();
          var tmp_3 = IconView$_get_shown_$ref_js8irt(element_0);
          var tmp_4 = getPropertyCallableRef('shown', 0, tmp_2, tmp_3, IconView$_set_shown_$ref_9ilxmr(element_0));
          element_0.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
            var tmp0 = $this$invoke.invoke_r7m7el_k$(this.notifications_1);
            var tmp$ret$38;
            $l$block_0: {
              // Inline function 'kotlin.collections.any' call
              var tmp;
              if (isInterface(tmp0, Collection())) {
                tmp = tmp0.isEmpty_y1axqb_k$();
              } else {
                tmp = false;
              }
              if (tmp) {
                tmp$ret$38 = false;
                break $l$block_0;
              }
              var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
              while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
                var element = _iterator__ex2g4s.next_20eer_k$();
                if (element.read_1 == null) {
                  tmp$ret$38 = true;
                  break $l$block_0;
                }
              }
              tmp$ret$38 = false;
            }
            return tmp$ret$38;
          });
          var tmp_5 = KMutableProperty0();
          var tmp_6 = IconView$_get_visible_$ref_7ldslk(element_0);
          var tmp_7 = getPropertyCallableRef('visible', 0, tmp_5, tmp_6, IconView$_set_visible_$ref_mp0dqc(element_0));
          element_0.invoke_bnq13k_k$(tmp_7, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(it).read_1 == null);
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_0 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_0.willAddChild_hz2iwc_k$(element_1);
          element_1.set_vertical_nuap32_k$(true);
          element_1.set_gap_jwjroq_k$(get_dp(0));
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          var this_1 = dynamicThemed(element_1, ($this$dynamicThemed) => {
            var tmp;
            if ($this$dynamicThemed.invoke_r7m7el_k$(it).read_1 == null) {
              // Inline function 'com.lightningkite.kiteui.models.ThemeDerivation' call
              tmp = new (NotificationListPage$render$$inlined$page$12$7$1())();
            } else {
              tmp = null;
            }
            return tmp;
          });
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_2 = new (TextView())(this_1.get_context_h02k06_k$());
          ensureOutermostElement(element_2);
          this_1.willAddChild_hz2iwc_k$(element_2);
          var tmp_8 = KMutableProperty0();
          var tmp_9 = TextView$_get_content_$ref_4pzcwl(element_2);
          var tmp_10 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb(element_2));
          element_2.invoke_bnq13k_k$(tmp_10, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(it).content_1.subject_1);
          element_2.onStartup_vrxh3i_k$();
          this_1.addChild_2qpft2_k$(element_2);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          var this_2 = themed(element_1, SmallTextSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_3 = new (TextView())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_3);
          this_2.willAddChild_hz2iwc_k$(element_3);
          var tmp_11 = KMutableProperty0();
          var tmp_12 = TextView$_get_content_$ref_4pzcwl(element_3);
          var tmp_13 = getPropertyCallableRef('content', 0, tmp_11, tmp_12, TextView$_set_content_$ref_pketfb(element_3));
          element_3.invoke_bnq13k_k$(tmp_13, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(it).content_1.body_1);
          element_3.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_3);
          element_1.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          $this$custom.addChild_2qpft2_k$(element);
          return Unit_instance;
        });
        var tmp_14 = Companion_instance_3;
        var tmp_15 = NotificationListPage$render$lambda_3;
        var tmp_16 = [tmp_13, tmp_14.text_y5ktm4_k$(tmp_15, 0.5, NotificationListPage$render$lambda_4)];
        tableRecycler(tmp_8, tmp_9, tmp_10, tmp_16, NotificationListPage$render$lambda_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_9 = shownWhen(element, VOID, VOID, NotificationListPage$render$lambda_6);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (Space())(this_9.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_6);
        this_9.willAddChild_hz2iwc_k$(element_6);
        element_6.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_6);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'NotificationListPage', NotificationListPage, VOID, [Page()]);
    NotificationListPageClass = $;
  }
  return NotificationListPageClass;
}
//region block: exports
export {
  SortOption as SortOptiong6pa3ijnod8n,
  NotificationListPage as NotificationListPagec9eun7x3iu4r,
};
//endregion

//# sourceMappingURL=NotificationListPage.mjs.map
